var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHotel = function SvgHotel(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3411154,94 L10.6588846,94 C8.08560308,94 6,91.8746963 6,89.2524305 L6,21.0100875 C6,13.2807487 12.1634242,7 19.7483787,7 L48.2516213,7 C55.8365758,7 62,13.2807487 62,21.0100875 L62,89.2524305 C62,91.8746963 59.9143969,94 57.3411154,94 Z M15.3177691,84.5048616 L52.692607,84.5048616 L52.692607,21.0100875 C52.692607,18.5147059 50.7003891,16.4951386 48.2619974,16.4951386 L19.7483787,16.4951386 C17.2996109,16.4951386 15.3177691,18.5252795 15.3177691,21.0100875 L15.3177691,84.5048616 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9988862,94 L5.00111383,94 C2.23880597,94 0,91.0902002 0,87.5 C0,83.9097998 2.23880597,81 5.00111383,81 L94.9988862,81 C97.7611938,81 100,83.9097998 100,87.5 C100,91.0902002 97.7611938,94 94.9988862,94 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,94 C70.9097998,94 68,91.6307983 68,88.7076044 L68,68.2923955 C68,65.3692015 70.9097998,63 74.5,63 C78.0902002,63 81,65.3692015 81,68.2923955 L81,88.7076044 C81,91.6307983 78.0902002,94 74.5,94 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2371807,69 C66.0902913,69 59.4743608,63.003125 59.4743608,55.640625 C59.4743608,48.278125 66.1012266,42.28125 74.2371807,42.28125 C82.3731341,42.28125 89,48.278125 89,55.640625 C89,63.003125 82.3840695,69 74.2371807,69 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2371807,51.1677083 C71.5033247,51.1677083 69.2834345,53.1765625 69.2834345,55.640625 C69.2834345,58.1145833 71.5033247,60.1135417 74.2371807,60.1135417 C76.9601007,60.1135417 79.1800716,58.1046875 79.1800716,55.640625 C79.1909263,53.1765625 76.9710361,51.1677083 74.2371807,51.1677083 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6849416,45.8864583 L23.9100045,45.8864583 C21.1980198,45.8864583 19,43.8973958 19,41.4432292 C19,38.9890625 21.1980198,37 23.9100045,37 L40.6849416,37 C43.3969262,37 45.5949461,38.9890625 45.5949461,41.4432292 C45.5949461,43.8973958 43.3969262,45.8864583 40.6849416,45.8864583 L40.6849416,45.8864583 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6849416,68.5578125 L23.9100045,68.5578125 C21.1980198,68.5578125 19,66.56875 19,64.1145833 C19,61.6604167 21.1980198,59.6713542 23.9100045,59.6713542 L40.6849416,59.6713542 C43.3969262,59.6713542 45.5949461,61.6604167 45.5949461,64.1145833 C45.5949461,66.56875 43.3969262,68.5578125 40.6849416,68.5578125 L40.6849416,68.5578125 Z",
    fill: "currentColor"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHotel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "hotel.47bbea5064c92d2c0064170d214f139e.svg";